import { PHIC_EMPLOYEE_SHARE_KEYS } from "../payrollReportConfig";
import {
  buildEmployeeAmountPipeline,
  buildNamedContributionSum,
  buildPayrollAmountLookups,
} from "./shared";

const PHIC_EMPLOYEE_SHARE_SUM = buildNamedContributionSum(
  PHIC_EMPLOYEE_SHARE_KEYS,
);

export const PHIC_EMPLOYEE_SHARE_LOOKUPS = buildPayrollAmountLookups(
  "phicEmployeeShare",
  "employeeShare",
  PHIC_EMPLOYEE_SHARE_SUM,
);

export function getPhicEmployeeShareByEmployeePipeline(employeeIds = []) {
  return buildEmployeeAmountPipeline(
    employeeIds,
    "employeeShare",
    PHIC_EMPLOYEE_SHARE_SUM,
  );
}
